import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import PaneHeader from './PaneHeader'

const ColorMenu = ({
  title,
  selectionStore,
  dataStore,
  uiStore,
  t,
  handleSubmit,
  handleCloseClick,
  handleResetColor,
  showRecentColors,
  onTransparencyChange,
  isColorPane = false
}) => {
  const onColorChangeHandler = (e) => {
    const value = Number(e && e.target ? e.target.value : e)
    selectionStore.selectedColor = value
    if (isColorPane) {
      const itemToEdit = selectionStore.colorEditItem
      if (itemToEdit) {
        itemToEdit.color_id = value
        if (itemToEdit.geopolygons) {
          itemToEdit.geopolygons.forEach(p => { p.color_id = value })
        }
        if (itemToEdit.boundaries) {
          itemToEdit.boundaries.forEach(b => { b.color_id = value })
        }
        if (itemToEdit.zipCodeBoundaries) {
          itemToEdit.zipCodeBoundaries.forEach(z => { z.color_id = value })
        }
        if (itemToEdit.savedMarkers) {
          itemToEdit.savedMarkers.forEach(m => { m.color_id = value })
        }
      }
    }
  }

  const currentTransparency = (isColorPane
    ? selectionStore.colorEditItem?.transparency
    : selectionStore.selectedTransparency) ?? 50

  const onTransparencyChangeHandler = (e) => {
    const val = Number(e.target.value) || 50
    selectionStore.selectedTransparency = val
    if (typeof onTransparencyChange === 'function') {
      onTransparencyChange(val)
    }
    if (isColorPane) {
      const itemToEdit = selectionStore.colorEditItem
      if (itemToEdit) {
        itemToEdit.transparency = val
        if (itemToEdit.geopolygons) {
          itemToEdit.geopolygons.forEach(p => { p.transparency = val })
        }
        if (itemToEdit.boundaries) {
          itemToEdit.boundaries.forEach(b => { b.transparency = val })
        }
        if (itemToEdit.zipCodeBoundaries) {
          itemToEdit.zipCodeBoundaries.forEach(z => { z.transparency = val })
        }
      }
    }
  }

  return (
    <div className='color-menu'>
      <PaneHeader
        title={title || t('COLOR_MENU.PALLETE', { defaultValue: 'Field Color Pallete' })}
        onClose={handleCloseClick}
      />
      <div>
        {dataStore.markerColors.length > 0 && (
          <ul className='color-menu__list'>
            {dataStore.markerColors.map((color) => {
              const isSelected = selectionStore.selectedColor === color.id
              return (
                <li key={color.id}>
                  <label
                    htmlFor={`color-${color.id}`}
                    className={`color-menu__label ${isSelected ? 'selected' : ''}`}
                    style={{ backgroundColor: color.active_color }}
                  >
                    <input
                      onChange={onColorChangeHandler}
                      id={`color-${color.id}`}
                      type='radio'
                      name='color'
                      value={color.id}
                      checked={isSelected}
                    />
                  </label>
                </li>
              )
            })}
          </ul>
        )}
        {uiStore.showColorMenuTransparency && (
          <div className='color-menu__slider'>
            <label className='color-menu__trans-label' htmlFor='transparency'>
              <span className='color-menu__trans-text'>{t('COLOR_MENU.TRANSPARENCY')}</span>
              <input
                className='color-menu__trans-input'
                id='transparency'
                type='range'
                onChange={onTransparencyChangeHandler}
                value={currentTransparency}
                min={20}
                max={80}
                style={{
                  '--slider-fill': `${Math.max(0, Math.min(100, ((currentTransparency - 20) / (80 - 20)) * 100))}%`
                }}
              />
            </label>
            <div className='color-menu__slider-val-center'>{currentTransparency}%</div>
          </div>
        )}
        {showRecentColors && dataStore.recentColors.length > 0 && (
          <>
            <h3 className='color-menu__title-recent'>{t('COLOR_MENU.RECENT')}</h3>
            <ul className='color-menu__list'>
              {dataStore.recentColors.map((color) => {
                const isSelected = selectionStore.selectedColor === color.id
                return (
                  <li key={color.id}>
                    <label
                      htmlFor={`recent-${color.id}`}
                      className={`color-menu__label ${isSelected ? 'selected' : ''}`}
                      style={{ backgroundColor: color.active_color }}
                    >
                      <input
                        onChange={onColorChangeHandler}
                        id={`recent-${color.id}`}
                        type='radio'
                        name='color'
                        value={color.id}
                        checked={isSelected}
                      />
                    </label>
                  </li>
                )
              })}
            </ul>
          </>
        )}
        <div className='color-menu__controls'>
          <div className='color-menu__controls-top'>
            <button type='button' className='outline-btn' onClick={handleCloseClick}>{t('GLOBAL.CANCEL')}</button>
            <button type='submit' className='full-btn' onClick={handleSubmit}>{t('GLOBAL.APPLY')}</button>
          </div>
          <button type='button' className='underlined-btn' onClick={handleResetColor}>{t('COLOR_MENU.RESET')}</button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation()(inject('selectionStore', 'dataStore', 'uiStore')(observer(ColorMenu)))
